module.exports = {
    "tooltip__close": {
        "close": "Закрыть"
    }
};